<div class="cashout-container">
  @if (isLoading()) {
    <app-spinner />
  }
  <ngx-app-bar
    class="w-100"
    [title]="'برداشت از کیف پول'"
    [rightButton]="{
      icon: 'arrow-right',
      style: 'neutral-link',
      mode: 'icon-only',
      size: 'medium',
    }"
    (onRightButtonClick)="onBackHandler()"
  />
  <div class="cashout-content px-plus">
    <div class="cashout-card">
      <div class="wallet-balance">
        <div
          class="d-flex wallet-description b-1 justify-content-center gap-small"
          (click)="showPurchasePowerInfo()"
        >
          قدرت خرید
          <img
            [className]="'cursor-pointer'"
            src="wealth-assets/icons/question.svg"
            alt="قدرت خرید"
          />
        </div>
        <div class="wallet-amount">
          <span class="wallet-number">{{ balance().balance | number }}</span>
          <span class="is-currency">ریال</span>
        </div>
      </div>
      <div class="wallet-balance">
        <div
          class="d-flex wallet-description b-1 justify-content-center gap-small"
          (click)="showWalletBalanceInfo()"
        >
          موجودی قابل برداشت
          <img
            [className]="'cursor-pointer'"
            src="wealth-assets/icons/question.svg"
            alt="قدرت خرید"
          />
        </div>
        <div class="wallet-amount">
          <span class="wallet-number">{{ balance().withdrawalBalance | number }}</span>
          <span class="is-currency">ریال</span>
        </div>
      </div>
      <div class="cashout-description">
        <div>
          <img src="wealth-assets/icons/information.svg" />
        </div>
        <span
          >اگر تا ساعت ۱۴ روز کاری درخواست خود را ثبت کنید، مبلغ ثبت شده ۱ روز کاری بعد و درخواست پس از ساعت ۱۴ و یا در روز های تعطیل ۲ روز
          کاری بعد به حساب متصل به سجامتان واریز خواهد شد.</span
        >
      </div>
    </div>

    <wealth-applet-wallet-amount-form
      class="w-100"
      [minAmount]="minAmount()"
      [maxAmount]="balance().withdrawalBalance"
      [type]="'cashOut'"
      (amountChange)="amountChanged($event)"
    />
  </div>

  <div class="w-100 buttons-container">
    <div class="d-grid gap-medium px-plus">
      <ngx-button
        [style]="'tinted-on-elevated'"
        [fullWidth]="true"
        [mode]="'form'"
        size="medium"
        (clickHandler)="showCashoutConfirmPayment('all')"
      >
        برداشت تمام موجودی
      </ngx-button>
      <ngx-button
        [style]="'fill'"
        [fullWidth]="true"
        [mode]="'form'"
        size="medium"
        [disabled]="!isValid()"
        (clickHandler)="showCashoutConfirmPayment()"
      >
        تایید و ادامه
      </ngx-button>
    </div>
  </div>
</div>
